import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Separator } from '../ui/separator';
import { 
  Search, 
  Plus, 
  Save, 
  X, 
  HelpCircle,
  ArrowUp,
  ArrowDown,
  CornerDownLeft,
  Navigation
} from 'lucide-react';

const SHORTCUT_GROUPS = [
  {
    title: 'Navegação',
    shortcuts: [
      { keys: ['Ctrl', 'K'], description: 'Abrir busca global', icon: Search },
      { keys: ['?'], description: 'Mostrar atalhos de teclado', icon: HelpCircle },
    ]
  },
  {
    title: 'Ações',
    shortcuts: [
      { keys: ['Ctrl', 'N'], description: 'Novo registro (em páginas com formulário)', icon: Plus },
      { keys: ['Ctrl', 'S'], description: 'Salvar (em formulários)', icon: Save },
      { keys: ['Esc'], description: 'Fechar modal/diálogo', icon: X },
    ]
  },
  {
    title: 'Navegação em Listas',
    shortcuts: [
      { keys: ['↑', '↓'], description: 'Navegar entre itens', icon: Navigation },
      { keys: ['Enter'], description: 'Selecionar item', icon: CornerDownLeft },
    ]
  }
];

function ShortcutKey({ children }) {
  return (
    <kbd className="inline-flex items-center justify-center min-w-[24px] h-6 px-2 text-xs font-medium bg-muted border rounded shadow-sm">
      {children}
    </kbd>
  );
}

export function KeyboardShortcutsHelp({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <HelpCircle className="h-5 w-5" />
            Atalhos de Teclado
          </DialogTitle>
          <DialogDescription>
            Use estes atalhos para navegar mais rapidamente pelo sistema
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 mt-4">
          {SHORTCUT_GROUPS.map((group, groupIndex) => (
            <div key={group.title}>
              {groupIndex > 0 && <Separator className="mb-4" />}
              <h4 className="text-sm font-semibold text-muted-foreground mb-3">
                {group.title}
              </h4>
              <div className="space-y-3">
                {group.shortcuts.map((shortcut, index) => {
                  const Icon = shortcut.icon;
                  return (
                    <div 
                      key={index} 
                      className="flex items-center justify-between"
                    >
                      <div className="flex items-center gap-2 text-sm">
                        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
                        <span>{shortcut.description}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        {shortcut.keys.map((key, keyIndex) => (
                          <span key={keyIndex} className="flex items-center">
                            {keyIndex > 0 && (
                              <span className="mx-1 text-muted-foreground text-xs">+</span>
                            )}
                            <ShortcutKey>{key}</ShortcutKey>
                          </span>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t text-xs text-muted-foreground text-center">
          Pressione <ShortcutKey>Esc</ShortcutKey> para fechar este diálogo
        </div>
      </DialogContent>
    </Dialog>
  );
}
